import { Button, Container, Grid, Step, StepContent, StepLabel, Stepper } from '@mui/material'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { esES } from '@mui/x-date-pickers/locales'
import esLocale from 'date-fns/locale/es'
import { useContext, useEffect, useState } from 'react'

import { ApplicationContext } from '../../Contexts'
import { Candidate } from '../../types'
import { HobbiesStep, JobsStep, PersonalDataStep, PhotoStep, ProfessionStep, ReferencesStep, SkillsStep } from './Steps'
import { useRegisterCandidate } from './hooks'
import { FormHandleSubmit } from './types'

const theme = createTheme({}, esES)

export const CandidatesRegister = () => {
  const { user } = useContext(ApplicationContext)
  const [activeStep, setActiveStep] = useState(0)
  const [activeForm, setActiveForm] = useState<FormHandleSubmit>()
  const [formValues, setFormValues] = useState<Partial<Candidate>>()
  const [candidate, registerCandidate] = useRegisterCandidate()
  const previousStep = () => {
    if (activeForm) {
      const stepCount =
        (activeForm.getData().experience || formValues?.personalData?.experience) === 'Primer empleo' &&
        activeStep === 2
          ? 2
          : 1
      setFormValues({ ...formValues, [activeForm.formId]: activeForm.getData() })
      setActiveStep((prevActiveStep) => prevActiveStep - stepCount)
    }
  }
  const nextStep = () => {
    if (activeForm)
      activeForm.submit(
        (data) => {
          const stepCount =
            (activeForm.getData().experience || formValues?.personalData?.experience) === 'Primer empleo' &&
            activeStep === 0
              ? 2
              : 1
          setFormValues({ ...formValues, [activeForm.formId]: activeForm.getData() })
          setActiveStep((prevActiveStep) => prevActiveStep + stepCount)
        },
        (errors) => {
          console.log(errors)
          // setFormValues({ ...formValues, [activeForm.formId]: activeForm.getData() })
          // setActiveStep((prevActiveStep) => ++prevActiveStep)
        },
      )()
  }
  const allowPreviousStep = () => activeStep > 0
  const allowNextStep = () => activeStep < 6
  const submit = () => {
    if (activeForm) {
      activeForm.submit(
        async () => {
          const finalData = {
            ...formValues,
            [activeForm.formId]: activeForm.getData(),
          }
          setFormValues({ ...formValues, [activeForm.formId]: activeForm.getData() })

          await registerCandidate({ ...finalData } as Candidate)
          alert('Salvo com sucesso')
        },
        async (errors) => {
          setFormValues({ ...formValues, [activeForm.formId]: activeForm.getData() })

          // await registerCandidate({ id: user?.uid, ...formValues } as Candidate)
          // alert('Salvo com sucesso')
        },
      )()
    }
  }

  useEffect(() => {
    if (user) 
      setFormValues(user)
  }, [user])

  return (
    formValues ? <ThemeProvider theme={theme}>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
      <Container fixed>
        <Stepper activeStep={activeStep} orientation="vertical">
          <Step>
            <StepLabel>Datos Personales</StepLabel>
            <StepContent>
              <PersonalDataStep id="personalData" data={formValues?.personalData} setActiveForm={setActiveForm} />
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Empresas</StepLabel>
            <StepContent>
              <JobsStep id="jobs" data={formValues?.jobs} setActiveForm={setActiveForm} />
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Competencias</StepLabel>
            <StepContent>
              <SkillsStep id="skills" data={formValues?.skills} setActiveForm={setActiveForm} />
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Pretensiones</StepLabel>
            <StepContent>
              <ProfessionStep id="profession" data={formValues?.profession} setActiveForm={setActiveForm} />
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Hobby &amp; Entretenimiento</StepLabel>
            <StepContent>
              <HobbiesStep id="hobbies" data={formValues?.hobbies} setActiveForm={setActiveForm} />
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Referencias</StepLabel>
            <StepContent>
              <ReferencesStep id="references" data={formValues?.references} setActiveForm={setActiveForm} />
            </StepContent>
          </Step>
          <Step>
            <StepLabel>Foto</StepLabel>
            <StepContent>
              <PhotoStep id="photo" data={formValues?.photo} setActiveForm={setActiveForm} />
            </StepContent>
          </Step>
        </Stepper>

        <Grid item xs={12} sm={6} md={6} style={{ marginTop: 30, marginBottom: 30 }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Button
              variant="contained"
              color="secondary"
              type="button"
              onClick={() => previousStep()}
              disabled={!allowPreviousStep()}
            >
              Volver
            </Button>
            <Button
              variant="contained"
              color="success"
              type="button"
              onClick={() => submit()}
              style={allowNextStep() ? { display: 'none' } : {}}
            >
              Enviar Currículum
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="button"
              onClick={() => nextStep()}
              disabled={!allowNextStep()}
            >
              Continuar
            </Button>
          </Grid>
        </Grid>
      </Container>
    </LocalizationProvider>
  </ThemeProvider> : <div></div>
  )
}

export default CandidatesRegister
